import { render, staticRenderFns } from "./vedio.vue?vue&type=template&id=0cc2cf78&scoped=true&"
import script from "./vedio.vue?vue&type=script&lang=js&"
export * from "./vedio.vue?vue&type=script&lang=js&"
import style0 from "./vedio.vue?vue&type=style&index=0&lang=css&"
import style1 from "./vedio.vue?vue&type=style&index=1&id=0cc2cf78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc2cf78",
  null
  
)

export default component.exports